
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { getStartDateTime, getEndDateTime } from '../../../utils/date.util';
import { cloneData } from '@/utils/general.util';
import { DataCollectionPeriodDTO } from '@/store/modules/projects/types/projects.types';
const dirtyMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

@Component({ components: {} })
export default class ProjectCreationMultipleDatePicker extends Vue {
  @Prop()
  public datepickerItem!: DataCollectionPeriodDTO;
  @Prop()
  public periodIndex!: number;

  public dirtyDatepickerItem: DataCollectionPeriodDTO = cloneData(
    this.datepickerItem,
  );
  public dirtyPeriodRange: Date[] = [];
  public showEditLabelInput: boolean = false;
  public newLabel: string = '';
  public emptyLabelError: boolean = false;

  public mounted() {
    const startDate: Date = getStartDateTime(
      this.dirtyDatepickerItem.startDate,
    );
    const endDate: Date = getStartDateTime(this.dirtyDatepickerItem.endDate);
    this.dirtyPeriodRange.push(startDate);
    this.dirtyPeriodRange.push(endDate);
  }

  public getDate(newValue: Date): string {
    return (
      newValue.getDate() +
      ' ' +
      dirtyMonths[newValue.getMonth()] +
      ' ' +
      newValue.getFullYear()
    );
  }

  public formatDataCollectionDateRange(date: Date[]): string {
    if (date && date.length) {
      return this.getDate(date[0]) + ' - ' + this.getDate(date[1]);
    }
    return '';
  }

  public updateDatePeriod(newValue: Date[]) {
    const dataCollectionPeriodDate: {
      auditName: string;
      auditNumber: number;
      startDate: Date;
      endDate: Date;
    } = {
      auditName: this.dirtyDatepickerItem.auditName,
      auditNumber: this.periodIndex,
      startDate: getStartDateTime(newValue[0]),
      endDate: getEndDateTime(newValue[1]),
    };
    this.$emit('updateDatePicker', dataCollectionPeriodDate);
  }
}
